import React from "react";
import { Stack } from "@mui/material";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import {
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { SettingsContainer } from "../../../../../components/SettingsContainer";
import { useSurveyStore } from "../../../../store/Hooks";
import { SettingsCheckboxComponent } from "../SettingsCheckboxComponent";
import { SurveySettingsTab } from "../SurveySettingsPaneTab";
import { SurveySettingsTabContentHeader } from "../SurveySettingsTabContentHeader";

export const SurveySettingsAdvancedFeaturesTab: React.FC = observer(() => {
  const { t } = useTranslation();
  const spacing = useSpacing();
  const typography = useTypography();
  const tokens = useFoundationColorTokens();
  const surveyStore = useSurveyStore();

  const surveySettings =
    surveyStore.backOfficeSurveySettingsStore.updatedBackOfficeSurveySettings
      ?.surveySettings;

  if (!surveySettings) return;

  return (
    <Stack id={SurveySettingsTab.AdvancedFeatures}>
      <SurveySettingsTabContentHeader
        title={t(
          "surveys.settings.advancedFeaturesSectionLabel",
          "Advanced Features",
        )}
      />
      <SettingsContainer
        settingHeadingText={t(
          "surveys.settings.advancedFeaturesSettings.speechToTextTitleText",
        )}
        spacing={spacing}
        typography={typography}
        tokens={tokens}
      >
        <Stack width="400px">
          <SettingsCheckboxComponent
            isCheckboxSelected={surveySettings.isSpeechToTextEnabled}
            setIsCheckboxSelected={surveySettings.setIsSpeechToTextEnabled}
            checkboxLabel={t(
              "surveys.settings.advancedFeaturesSettings.enableSpeechToTextLabelText",
            )}
            checkboxDescription={t(
              "surveys.settings.advancedFeaturesSettings.enableSpeechToTextDescriptionText",
            )}
            spacing={spacing}
            typography={typography}
            tokens={tokens}
          />
        </Stack>
      </SettingsContainer>
    </Stack>
  );
});
